import api from './client';
import type {
  CreateAssetTypePayload,
  UpdateAssetTypePayload,
  UpdateAssetTypeFieldsPayload,
  GetAssetTypesResponse,
  GetAssetTypeGetStartedOptionsResponse,
  SaveAssetTypeGetStartedPayload,
  SaveAssetTypeGetStartedResponse,
  GetAssetTypewithFieldsResponse,
  AssetTypeKind,
  FieldSection,
  FieldSet,
} from '@gokrew/models/asset-type';

// Base URL
function getAssetTypesBase(companyId: string) {
  return `/companies/${companyId}/asset-types` as const;
}

function getFieldsBase(companyId: string) {
  return `/companies/${companyId}/asset-fields` as const;
}

function getFieldSetsBase(companyId: string) {
  return `/companies/${companyId}/asset-field-sets` as const;
}

/* Asset Types APIs */
export async function getAssetTypes(
  companyId: string,
  type?: AssetTypeKind,
  lang?: string
) {
  const res = await api.get<GetAssetTypesResponse>(
    getAssetTypesBase(companyId),
    { params: { type, lang } }
  );

  return res.data;
}

export async function getAssetTypesGetStartedOptions(companyId: string) {
  const res = await api.get<GetAssetTypeGetStartedOptionsResponse>(
    `${getAssetTypesBase(companyId)}/get-started/options`
  );

  return res.data;
}

export async function saveAssetTypesGetStarted(
  companyId: string,
  payload: SaveAssetTypeGetStartedPayload
) {
  const res = await api.post<SaveAssetTypeGetStartedResponse>(
    `${getAssetTypesBase(companyId)}/get-started`,
    payload
  );

  return res.data;
}

export async function getAssetTypeById(
  companyId: string,
  id: string,
  lang?: string
) {
  const res = await api.get<GetAssetTypewithFieldsResponse>(
    `${getAssetTypesBase(companyId)}/${id}`,
    { params: { lang } }
  );

  return res.data;
}

export async function createAssetType(
  companyId: string,
  payload: CreateAssetTypePayload
) {
  const res = await api.post<GetAssetTypewithFieldsResponse>(
    getAssetTypesBase(companyId),
    payload
  );

  return res.data;
}

export async function updateAssetType(
  companyId: string,
  id: string,
  payload: UpdateAssetTypePayload
) {
  const res = await api.patch<GetAssetTypewithFieldsResponse>(
    `${getAssetTypesBase(companyId)}/${id}`,
    payload
  );

  return res.data;
}

export async function updateAssetTypeFieldConfigs(
  companyId: string,
  id: string,
  payload: UpdateAssetTypeFieldsPayload
) {
  const res = await api.patch<GetAssetTypewithFieldsResponse>(
    `${getAssetTypesBase(companyId)}/${id}/fields`,
    payload
  );

  return res.data;
}

/* Field Sections APIs */

export async function getFieldSections(companyId: string, lang?: string) {
  const res = await api.get<{ data: FieldSection[] }>(
    `${getFieldsBase(companyId)}/sections`,
    { params: { lang } }
  );

  return res.data;
}

export async function getFieldSets(companyId: string, lang?: string) {
  const res = await api.get<{ data: FieldSet[] }>(getFieldSetsBase(companyId), {
    params: { lang },
  });

  return res.data;
}

export async function getFieldSetById(
  companyId: string,
  id: string,
  lang?: string
) {
  const res = await api.get<{ data: FieldSet }>(
    `${getFieldSetsBase(companyId)}/${id}`,
    { params: { lang } }
  );

  return res.data;
}
